var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { C } from '#integrations';
import { AlertTriangleIcon } from '../../../icons';
import { Typography } from '../../../Typography';
import { FieldErrorTestIdFactory } from './interactions';
import styles from './FieldError.module.css';
export const FieldError = ({ 'aria-hidden': ariaHidden, children, className, 'data-testid': testid, }) => {
    return (_jsxs("div", { className: C(styles.Container, className), "data-testid": FieldErrorTestIdFactory.getFieldErrorListItemTestId(testid), ...(ariaHidden && { 'aria-hidden': true }), children: [_jsx("div", { className: styles.IconContainer, children: _jsx(AlertTriangleIcon, { className: styles.Icon, color: "negative", size: "xsmall" }) }), _jsx(Typography, { color: "negative", kind: "p-small", children: children })] }));
};
_react_refresh_temp_1 = FieldError;
$RefreshReg$(_react_refresh_temp_1, "FieldError");
